import { render, staticRenderFns } from "./ModifySubscriptionPage.vue?vue&type=template&id=53c41aa5&scoped=true&"
import script from "./ModifySubscriptionPage.vue?vue&type=script&lang=ts&"
export * from "./ModifySubscriptionPage.vue?vue&type=script&lang=ts&"
import style0 from "./ModifySubscriptionPage.vue?vue&type=style&index=0&id=53c41aa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c41aa5",
  null
  
)

export default component.exports